var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mian-msg"},[_c('titles',{attrs:{"name":"常见问题"}}),_c('div',{staticClass:"black-msg"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"item"},[_vm._v(_vm._s(item.msg))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }